// src/components/ui/Table/TableBody.tsx
import { useTranslation } from 'react-i18next';
import { TableColumn } from './Table';
import { TableRow } from './TableRow';
import styles from './TableBody.module.css';

interface TableBodyProps<T> {
  data: T[];
  columns: TableColumn<T>[];
  onRowClick?: (item: T, index: number) => void;
  isLoading: boolean;
  keyExtractor: (item: T, index: number) => string | number;
  emptyText: string;
  loadingText: string;
  columnWidths?: Record<string, number>;
  containerWidth?: number; // Ширина контейнера для адаптивности
  responsive?: boolean; // Флаг адаптивности
  compactMode?: boolean; // Новый параметр для компактного режима
}

export function TableBody<T>({
  data,
  columns,
  onRowClick,
  isLoading,
  keyExtractor,
  emptyText,
  loadingText,
  columnWidths = {},
  compactMode = false
}: TableBodyProps<T>) {
  // Используем хук для переводов
  useTranslation('ui');

  // Определяем дополнительные классы для компактного режима
  const compactClass = compactMode ? styles.compact : '';

  if (isLoading) {
    return (
      <tbody className={`${styles.tableBody} ${compactClass}`}>
        <tr className={styles.loadingRow}>
          <td 
            colSpan={columns.length} 
            className={styles.loadingCell}
          >
            <div className={styles.loadingContainer}>
              <div className={styles.spinner}></div>
              <span>{loadingText}</span>
            </div>
          </td>
        </tr>
      </tbody>
    );
  }

  if (data.length === 0) {
    return (
      <tbody className={`${styles.tableBody} ${compactClass}`}>
        <tr className={styles.emptyRow}>
          <td 
            colSpan={columns.length} 
            className={styles.emptyCell}
          >
            {emptyText}
          </td>
        </tr>
      </tbody>
    );
  }

  // Функция для расчета ширины столбца с учетом адаптивности


  return (
    <tbody className={`${styles.tableBody} ${compactClass}`}>
      {data.map((item, index) => (
        <TableRow 
          key={keyExtractor(item, index)}
          item={item}
          index={index}
          columns={columns}
          onClick={onRowClick ? () => onRowClick(item, index) : undefined}
          columnWidths={columnWidths}
          compactMode={compactMode}
        />
      ))}
    </tbody>
  );
}